import { Component, Input, OnInit, Optional } from '@angular/core';
import { NbDialogRef, NbCardModule, NbButtonModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-basic-dialog',
    templateUrl: './basic-dialog.component.html',
    styleUrls: ['./basic-dialog.component.scss'],
    standalone: true,
    imports: [
      NbCardModule,
      NbButtonModule,
      TranslateModule
  ],
})
export class BasicDialogComponent implements OnInit {

  @Input() public canCancel: boolean = true;

  public title: string = '';
  public content: string = '';
  public contentBis: string = '';

  constructor(
    @Optional() public ref: NbDialogRef<BasicDialogComponent>
  ) {
    const context = (this.ref as any)?.context || {};
    this.title = context.title || this.title;
    this.content = context.content || this.content;
    this.contentBis = context.contentBis || this.contentBis;
    this.canCancel = context.canCancel !== undefined ? context.canCancel : this.canCancel;
  }

  public ngOnInit(): void { }

  public close(confirmation: boolean = false): void {
    if (this.ref) {
      this.ref.close(confirmation);
    }
  }
}
